export const FETCH_SUPPORTTYPES_INIT_ACTION =
  "FETCH_SUPPORTTYPES_INIT_ACTION";
export const FETCH_SUPPORTTYPES_SUCCESS_ACTION =
  FETCH_SUPPORTTYPES_INIT_ACTION + "_SUCCESS";
export const FETCH_SUPPORTTYPES_FAIL_ACTION =
  FETCH_SUPPORTTYPES_INIT_ACTION + "_ERROR";

export const POST_SUPPORTQUERY_INIT_ACTION = "POST_SUPPORTQUERY_INIT_ACTION";
export const POST_SUPPORTQUERY_SUCCESS_ACTION = POST_SUPPORTQUERY_INIT_ACTION + "_SUCCESS";
export const POST_SUPPORTQUERY_FAIL_ACTION = POST_SUPPORTQUERY_INIT_ACTION + "_FAIL";

export const GET_TICKETS_INIT_ACTION = "GET_TICKETS_INIT_ACTION";
export const GET_TICKETS_SUCCESS_ACTION = GET_TICKETS_INIT_ACTION + "_SUCCESS";
export const GET_TICKETS_FAIL_ACTION = GET_TICKETS_INIT_ACTION + "_FAIL";

export function getSupportTypes() {
  return {
    type: FETCH_SUPPORTTYPES_INIT_ACTION,
  };
}

export function sendSupportQuery(val){
    return {
        type:POST_SUPPORTQUERY_INIT_ACTION,
        value:val,
    }
}

export function getSupportTickets(val){
  return {
    type: GET_TICKETS_INIT_ACTION,
    value:val,
  }
}

export function SptpageSelected(val){
  return {
    type: GET_TICKETS_INIT_ACTION,
    value:val,
  }
}
